import React from 'react';
import { InputNumber, Select, Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface QueryParamsProps {
  year: number;
  month: number;
  deptLevel: number;
  deptFrom: string;
  deptTo: string;
  loading: boolean;
  onYearChange: (v: number) => void;
  onMonthChange: (v: number) => void;
  onDeptLevelChange: (v: number) => void;
  onDeptFromChange: (v: string) => void;
  onDeptToChange: (v: string) => void;
  onQuery: () => void;
}

const DEPT_LEVELS = [
  { value: 1, label: '部 (Level 1)' },
  { value: 2, label: '課 (Level 2)' },
  { value: 3, label: '組 (Level 3)' },
];

const QueryParams: React.FC<QueryParamsProps> = ({
  year, month, deptLevel, deptFrom, deptTo, loading,
  onYearChange, onMonthChange, onDeptLevelChange,
  onDeptFromChange, onDeptToChange, onQuery,
}) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">年度</span>
          <InputNumber
            value={year}
            onChange={(v) => onYearChange(v ?? new Date().getFullYear())}
            min={1990}
            max={2099}
            style={{ width: 90 }}
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">月份</span>
          <InputNumber
            value={month}
            onChange={(v) => onMonthChange(v ?? 1)}
            min={1}
            max={12}
            style={{ width: 70 }}
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">部門層級</span>
          <Select
            value={deptLevel}
            onChange={onDeptLevelChange}
            options={DEPT_LEVELS}
            style={{ width: 140 }}
          />
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium w-16">部門範圍</span>
          <Input
            value={deptFrom}
            onChange={(e) => onDeptFromChange(e.target.value.toUpperCase())}
            placeholder="起"
            style={{ width: 100 }}
            maxLength={10}
          />
          <span className="text-sm">~</span>
          <Input
            value={deptTo}
            onChange={(e) => onDeptToChange(e.target.value.toUpperCase())}
            placeholder="迄"
            style={{ width: 100 }}
            maxLength={10}
          />
        </div>
      </div>
      <div className="flex gap-2">
        <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
          查詢
        </Button>
      </div>
    </div>
  );
};

export default QueryParams;
